<template>
  <v-chip close class="mr-2 mt-2 pb-6 pt-6" @click:close="onRemove">
    <div>
      <small>{{ codigoProduto }}</small>
      {{ descricaoProduto | truncate(25) }}
      <div>
        <small> {{ requisicaoProduto.requisicao.identificador }} </small>
      </div>
    </div>
  </v-chip>
</template>
<script>
export default {
  props: {
    requisicaoProduto: {
      type: Object,
      required: true,
    },
  },
  computed: {
    codigoProduto() {
      return this.requisicaoProduto.produto ? `(${this.requisicaoProduto.produto.codigo})` : '';
    },
    descricaoProduto() {
      return this.requisicaoProduto.produto ? this.requisicaoProduto.produto.descricao
        : this.requisicaoProduto.especificacaoProduto;
    },
  },
  methods: {
    onRemove() {
      this.$emit('remove', this.requisicaoProduto);
    },
  },
};
</script>
